import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

export class KeyValuePair {
    key: string;
    value: any;

    constructor(key: string, value: any) {
        this.key = key;
        this.value = value;
    }
}

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    public key: ReplaySubject<KeyValuePair>;
    private storage: Storage;

    constructor() {
        this.storage = window.localStorage;
        this.key = new ReplaySubject<KeyValuePair>(1);
    }

    get(key: string, defaultValue: any = null) {
        try {
            const result = this.storage.getItem(key);
            if (result === null) {
                return defaultValue;
            }
            return JSON.parse(result);
        } catch (e) {
            return defaultValue;
        }
    }

    set(key: string, value: any) {
        this.storage.setItem(key, JSON.stringify(value));
        this.key.next(new KeyValuePair(key, value));
    }

    pop(key: string, defaultValue: any = null) {
        const result = this.get(key, defaultValue);
        if (this.storage.getItem(key) !== null) {
            this.storage.removeItem(key);
        }

        return result;
    }
}
